<template>
  <div class="atividades-sacsolicitacoes ml-4 mr-4">
    <b-form>
      <b-row>
        <!-- -->

        <b-col cols="4">
          <label for="selecao-status-sol">Status</label>

          <multiselect
            id="selecao-status-sol"
            v-model="value_status"
            required
            :options="statuss"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Selecione o(s) status"
            label="status"
            track-by="id_status"
            name="status"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span class="multiselect__single" v-if="values.length && !isOpen"
                >{{ values.length }} status selecionado(s)</span
              ></template
            >
          </multiselect>
        </b-col>

        <b-col cols="1">
          <br />
          <b-button
            variant="primary"
            class="mr-2 mt-2"
            @click="loadSacSolicitacoes()"
            block
          >
            Carregar
          </b-button>
        </b-col>

        <b-col cols="5" class="mb-0">
          <label for="input-busca">Pesquisa no grid </label>
          <b-form-input
            id="buscamonitoramento"
            v-model="search"
            required="required"
            placeholder="Registro ou Tipo de solicitação ou palavras na solicitação"
          ></b-form-input>
        </b-col>

        <!-- condicional para exibir o botão planilha-->
        <b-col cols="2">
          <br />
          <b-button
            variant="primary"
            class="mr-2 mt-2"
            @click="reset(), loadDepartamentos()"
            v-b-modal.modal-multi-2
            block
          >
            Novo
          </b-button>
        </b-col>
      </b-row>
    </b-form>

    <b-row>
      <b-col cols="3" class="mt-3">
        <b-card
          class="ml-2"
          style="width: 33rem"
          border-variant="primary"
          header="SOLICITAÇÕES PENDENTES"
          header-bg-variant="danger"
          header-text-variant="white"
          align="center"
        >
          <b-card-text>
            <h2>
              {{ itemsFiltered.filter((s) => s.status === "PENDENTE").length }}
            </h2>
          </b-card-text>
        </b-card>
      </b-col>

      <b-col cols="3" class="mt-3">
        <b-card
          class="mr-2"
          style="width: 33rem"
          border-variant="primary"
          header="SOLICITAÇÕES EM ATENDIMENTO"
          header-bg-variant="warning"
          header-text-variant="white"
          align="center"
        >
          <b-card-text>
            <h2>
              {{ itemsFiltered.filter((s) => s.status === "ANDAMENTO").length }}
            </h2>
          </b-card-text>
        </b-card>
      </b-col>

      <b-col cols="3" class="mt-3">
        <b-card
          class="mr-2"
          style="width: 33rem"
          border-variant="primary"
          header="SOLICITAÇÕES FINALIZADAS"
          header-bg-variant="success"
          header-text-variant="white"
          align="center"
        >
          <b-card-text>
            <h2>
              {{ itemsFiltered.filter((s) => s.status === "ATENDIDA").length }}
            </h2>
          </b-card-text>
        </b-card>
      </b-col>

      <b-col cols="3" class="mt-3">
        <b-card
          class="ml-2"
          style="width: 33rem"
          border-variant="primary"
          header="TOTAL SOLICITAÇÕES "
          header-bg-variant="primary"
          header-text-variant="white"
          align="center"
        >
          <b-card-text>
            <h2>
              {{ itemsFiltered.length }}
            </h2>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>

    <!--tbl de dados -->
    <b-table
      id="resolicitante"
      small
      hover
      striped
      sticky-header="762px"
      :items="itemsFiltered"
      :fields="fieldsSolicitado"
    >
      <template slot="cell(actions)" slot-scope="data">
        <b-button
          @click="
            loadCarregaSac(data.item),
              loadSacSolicitacoesTratativas(),
              loadStatus();
            loadResposta();
          "
          title="Editar solicitação"
          size="sm"
          variant="primary"
          class="mr-2 mt-2"
          v-b-modal.modal-multi-2
        >
          <i class="fa fa-exclamation-circle"></i>
        </b-button>
      </template>
    </b-table>

    <!--  MODAL SOLICITÇÕES  -->
    <div>
      <b-modal
        id="modal-multi-2"
        cancel-title="Fechar"
        ok-title="Gravar"
        @ok.prevent="postSac()"
        size="xl"
        :title="`Solicitação Nº.: ${
          sacsolicitacao.id_solicitacao != null
            ? sacsolicitacao.id_solicitacao
            : '-'
        }`"
        no-close-on-esc
        no-close-on-backdrop
      >
        <!-- ,postSacTratativa(),putSacTratativa(),postNotificacao() -->
        <div>
          <b-row
            v-if="
              sacsolicitacao.id_solicitacao !== '' &&
              sacsolicitacao.id_solicitacao !== null
            "
          >
            <input
              id="id-sac"
              type="hidden"
              v-model="sacsolicitacao.id_solicitacao"
            />

            <b-col cols="1" class="mt-2 pr-4">
              <b-form-group label="" label-for="tabela-foto">
                <b-img
                  height="120"
                  width="78"
                  class="mb-5"
                  v-model="sacsolicitacao.foto_url"
                  v-bind="mainProps"
                  rounded
                  alt="Foto"
                  :src="sacsolicitacao.foto_url"
                >
                </b-img>
              </b-form-group>
            </b-col>

            <b-col cols="2" class="mt-5">
              <label for="input-live">Registro</label>
              <b-form-input
                id="resolicitante"
                v-model="sacsolicitacao.re_solicitante"
                readonly
                placeholder=""
                class="mb-3"
              ></b-form-input>
            </b-col>

            <b-col cols="4" class="mt-5">
              <label for="input-live">Nome</label>
              <b-form-input
                id="resolicitante"
                v-model="sacsolicitacao.nome"
                readonly
                placeholder=""
                class="mb-3"
              ></b-form-input>
            </b-col>

            <b-col cols="3" class="mt-5">
              <label for="input-live">Função </label>
              <b-form-input
                id="resolicitante"
                v-model="sacsolicitacao.funcao_solicitante"
                readonly
                placeholder=""
              ></b-form-input>
            </b-col>

            <b-col cols="1" class="mt-5">
              <label for="input-live"> </label>
              <b-button
                block
                variant="warning"
                class="mr-2 mt-1"
                @click="loadSolicitacaoFoto()"
                v-b-modal.modal-SolicitacaoFotos
                >Fotos</b-button
              >
            </b-col>
          </b-row>

          <b-row
            v-if="
              sacsolicitacao.id_solicitacao == '' ||
              sacsolicitacao.id_solicitacao == null
            "
          >
            <b-col sm="3">
              <label for="textarea-small">Justificativa</label>
            </b-col>
            <b-col sm="12">
              <b-form-textarea
                id="id-pecas"
                v-model="sacsolicitacao.justificativa"
                readonly
                size="sm"
                class="mb-3"
                placeholder="Pergunta do colaborador"
              ></b-form-textarea>
            </b-col>
          </b-row>

          <b-row
            v-if="
              sacsolicitacao.id_solicitacao == '' ||
              sacsolicitacao.id_solicitacao == null
            "
          >
            <b-col cols="4" sm="4" class="mt-1">
              <label for="input-parecer">Departamento</label>
              <div>
                <b-form-select
                  id="infoFormato"
                  v-model="sacsolicitacao.departamento_id"
                  :options="departamentos"
                  class="mb-3"
                  text-field="area"
                  @change="loadAssunto()"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="4" sm="4" class="mt-1">
              <label for="input-parecer">Assunto</label>
              <div>
                <b-form-select
                  id="infoFormato"
                  v-model="sacsolicitacao.assunto_id"
                  :options="assuntos"
                  class="mb-3"
                  text-field="modulo"
                  @change="loadMotivo()"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="4" sm="4" class="mt-1">
              <label for="input-parecer">Motivo</label>

              <div>
                <b-form-select
                  id="infoFormato"
                  v-model="sacsolicitacao.motivo_id"
                  :options="motivos"
                  class="mb-3"
                  text-field="motivo"
                  value-field="id"
                >
                  <!-- Opcional: Slot para a opção padrão "Selecione" -->
                  <template #first>
                    <b-form-select-option :value="null" disabled
                      >-- Selecione um motivo --</b-form-select-option
                    >
                  </template>
                </b-form-select>
              </div>
            </b-col>
          </b-row>

          <!-- Exibir o bloco de datas e o valor de 'atestado' SOMENTE se um motivo estiver selecionado E 'atestado' for true -->
          <div
            v-if="
              sacsolicitacao.dt_atestado_ini ||
              (selectedMotivo && selectedMotivo.atestado)
            "
          >
            <b-row class="mb-4">
              <b-col cols="4">
                <div>
                  <label for="datepicker-placeholder"
                    >Data atestado inicio</label
                  >

                  <b-form-datepicker
                    id="dt_sol_inicial"
                    required
                    v-model="sacsolicitacao.dt_atestado_ini"
                    placeholder="Data inicial "
                    locale="pt-BR"
                    date-format-options="DD/MM/YYYY"
                  ></b-form-datepicker>
                </div>
              </b-col>

              <b-col cols="4">
                <div>
                  <label for="datepicker-placeholder"
                    >Data atestado término</label
                  >
                  <b-form-datepicker
                    id="dt_sol_final"
                    required
                    v-model="sacsolicitacao.dt_atestado_fim"
                    placeholder="Data do final"
                    locale="pt-BR"
                    date-format-options="DD/MM/YYYY"
                  ></b-form-datepicker>
                </div>
              </b-col>
            </b-row>
          </div>

          <!-- Tratativas -->

          <!--tbl de dados -->
          <b-table
            id="resolicitante"
            v-if="
              sacsolicitacao.id_solicitacao !== '' ||
              sacsolicitacao.id_solicitacao !== null
            "
            small
            hover
            striped
            sticky-header="330px"
            :items="sacsolicitacoestratativa"
            :fields="tratativas"
          >
          </b-table>

          <b-row>
            <b-col cols="12" class="mt-5">
              <label for="input-resolicitante">Resposta padrão</label>
              <div>
                <b-form-select
                  id="resolicitante"
                  v-model="sacResposta.id"
                  :options="sacResposta"
                  class="mb-3"
                  text-field="resposta"
                  value-field="id"
                  @change="atualizarParecer"
                />
              </div>
            </b-col>

            <b-col sm="12">
              <label for="textarea-small">Parecer da solicitação:</label>
            </b-col>

            <b-col cols="10">
              <b-form-textarea
                id="id-obs"
                v-model="sacsolicitacao.parecer"
                size="sm"
                placeholder="Digite o parecer"
              ></b-form-textarea>
            </b-col>

            <b-col v-if="this.user.gestor" cols="2" class="mb-1">
              <b-form-checkbox
                id="aprovado"
                v-model="sacsolicitacao.aprovado"
                name="checkbox-1"
                value="true"
                unchecked-value="false"
                checked="true"
                @change="handleCheckboxChange"
              >
                Aprovado compra
              </b-form-checkbox>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="10" class="mt-2" v-if="sacsolicitacao.id_status == 3">
              <label for="textarea-small">Avaliação do atendimento:</label>
              <b-form-rating
                v-model="sacsolicitacao.avaliacao"
                @change="uptAvaliacao()"
              ></b-form-rating>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="mb-3 mt-3 ml-5">
              <div>
                <b-img
                  v-if="sacsolicitacao.file === 'true'"
                  :src="sacsolicitacao.file"
                  width="600"
                  height="600"
                ></b-img>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-modal>
    </div>
    <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->

    <div>
      <b-modal
        id="modal-SolicitacaoFotos"
        hide-footer
        size="lg"
        :title="`Fotos da solicitação: ${sacsolicitacao.id_solicitacao}`"
        no-close-on-backdrop
      >
        <div class="d-flex justify-content-center" style="height: 80vh">
          <b-carousel
            id="carouselFoto"
            class="carouselFoto"
            v-model="slide"
            :interval="4000"
            controls
            indicators
            background="#ababab"
            style="text-shadow: 1px 1px 2px #333"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
          >
            <b-carousel-slide
              v-for="item in solicitacao"
              :key="item.id"
              :img-src="item.foto_thumbnail"
            ></b-carousel-slide>
          </b-carousel>
        </div>
      </b-modal>
    </div>
  </div>
</template>


<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import Multiselect from "vue-multiselect";
import moment, { now } from "moment";
import { mapState } from "vuex";
import * as XLSX from "xlsx";
import LoadingModal from "../utilitarios/LoadingModal";

export default {
  name: "SacSolicitacao",

  components: {
    Multiselect,
    LoadingModal,
  },

  computed: {
    ...mapState(["user"]),

    itemsFiltered() {
      let valores = [];
      // Garante que sacsolicitacoes é um array antes de filtrar
      if (Array.isArray(this.sacsolicitacoes)) {
        valores = this.sacsolicitacoes.filter((item) => {
          const searchLower = this.search.toLowerCase();
          return (
            (item.re_solicitante &&
              item.re_solicitante.toLowerCase().includes(searchLower)) ||
            (item.modulo && item.modulo.toLowerCase().includes(searchLower)) ||
            (item.id_solicitacao &&
              item.id_solicitacao.toLowerCase().includes(searchLower)) ||
            (item.justificativa &&
              item.justificativa.toLowerCase().includes(searchLower))
          );
        });
      }
      return valores;
    },

    // Propriedade computada para encontrar o objeto de motivo selecionado
    selectedMotivo() {
      // Retorna o objeto de motivo completo que corresponde ao motivo_id selecionado
      // Se sacsolicitacao.motivo_id for null ou não encontrado, retorna undefined
      return this.motivos.find(
        (motivo) => motivo.id === this.sacsolicitacao.motivo_id
      );
    },
    // Propriedade computada para exibir o valor de 'atestado' diretamente
    // Você pode usar esta ou 'selectedMotivo' dependendo da sua necessidade
    selectedMotivoAtestado() {
      return this.selectedMotivo ? this.selectedMotivo.atestado : "N/A";
    },
  },

  data: function () {
    return {
      sacsolicitacao: {}, // Objeto único para formulário de solicitação
      sacResposta: [], // Lista de respostas predefinidas
      sacsolicitacoes: [], // Lista principal de solicitações para a tabela
      sacT: {}, // Objeto para uma única tratativa (se usada)
      sacsolicitacoestratativa: [], // Lista de tratativas para uma solicitação
      search: "", // Campo de busca para a tabela
      departamentos: [],
      assuntos: [],
      motivos: [],
      idRetornoSolicitacao: null, // Armazenará o ID da solicitação recém-criada
      solicitacao: [], // Usado para carregar dados de foto, parece

      mode: "save", // Modo do formulário: 'save' (novo) ou 'update' (atualizar)

      empresa: {},
      empresas: [],
      value_empresa: [], // Seleção de empresa para filtro
      value_filial: [], // Seleção de filial para filtro
      value_status: [], // Seleção de status para filtro
      filial: {},
      filiais: [],

      status: {},
      statuss: [], // Lista de status

      permissoes: [], // Permissões do usuário (áreas)
      permissao: {},

      // Definição dos campos para a b-table de solicitações
      fieldsSolicitado: [
        { key: "id_solicitacao", label: "Nº Solicitação", sortable: true },
        { key: "id_filial", label: "Filial", sortable: true },
        { key: "re_solicitante", label: "Solicitante", sortable: true },
        { key: "funcao_solicitante", label: "Função", sortable: true },
        {
          key: "dt_cadastro",
          label: "Data_Abertura_Solicitação",
          sortable: true,
          formatter: (value) => {
            // Use 'value' diretamente
            return value ? moment(value).format("DD/MM/YYYY - HH:mm") : "-";
          },
        },
        {
          key: "dt_finalizada",
          label: "Data_Encerramento",
          sortable: true,
          formatter: (value) => {
            // Use 'value' diretamente
            return value ? moment(value).format("DD/MM/YYYY - HH:mm") : "-";
          },
        },
        { key: "tempo", label: "Duração", sortable: false },
        { key: "statuss", label: "Status", sortable: true }, // 'statuss' do backend
        { key: "area", label: "    Departamento    ", sortable: true },
        { key: "modulo", label: "Tipo_Solicitação", sortable: true },
        { key: "justificativa", label: "Solicitação", sortable: true },
        { key: "re_finalizado", label: "Encerrado_Por", sortable: true },
        { key: "parecer", label: "Resposta", sortable: true },
        {
          key: "exige_liberacao",
          label: "Exige aprovação",
          sortable: true,
          formatter: (value) => (value ? "Sim" : "Não"),
        },
        {
          key: "aprovado",
          label: "Aprovado",
          sortable: true,
          formatter: (value) => (value ? "Sim" : "Não"),
        },
        { key: "actions", label: "Atualizar" },
      ],

      // Definição dos campos para a b-table de tratativas
      tratativas: [
        {
          key: "dt_resposta",
          label: "Data_Resposta",
          sortable: true,
          formatter: (value) => {
            // Use 'value' diretamente
            return value ? moment(value).format("DD/MM/YYYY - HH:mm") : "-";
          },
        },
        { key: "respondido", label: "Resposta", sortable: true },
        { key: "registro", label: "Registro", sortable: true },
        { key: "justificativa", label: "Justificativa", sortable: true },
        { key: "status", label: "Status", sortable: true },
      ],
      socket: null, // Adiciona a instância do socket ao data
    };
  },

  methods: {
    // --- Métodos de Utilidade e Interface ---
    atualizarParecer(idSelecionado) {
      const respostaSelecionada = this.sacResposta.find(
        (item) => item.id === idSelecionado
      );
      if (respostaSelecionada) {
        this.sacsolicitacao.parecer = respostaSelecionada.resposta;
      }
    },

    handleCheckboxChange(value) {
      // Este método é chamado quando o checkbox de aprovação é alterado.
      // A lógica de `postSac()` já lida com a atualização do status `aprovado`.
      // Portanto, a chamada `this.postSac()` dentro deste método pode ser redundante
      // se `postSac` já é chamado ao submeter o formulário principal.
      // Se este checkbox é o gatilho principal para salvar, mantenha-o.
      // Caso contrário, pode ser removido ou a lógica ajustada.
      if (value === true || value === "true") {
        // Garante que seja um valor booleano ou string 'true'
        // this.postSac(); // Descomente se este é o único gatilho para salvar a aprovação
      }
    },

    reset() {
      // Limpa os dados do formulário e as tratativas
      this.idRetornoSolicitacao = null; // Reinicia para null
      this.sacsolicitacao = {}; // Zera o objeto da solicitação
      // Não zere `sacsolicitacao.id_solicitacao` e `sacsolicitacao.parecer` individualmente
      // se você zera o objeto `sacsolicitacao` completo.
      this.sacsolicitacoestratativa = []; // Limpa as tratativas mostradas no modal
      this.mode = "save"; // Retorna ao modo de criação
    },

    limparFiltro() {
      this.search = "";
      this.value_empresa = [];
      this.value_filial = [];
      this.value_status = [{ id_status: 1, status: "ABERTA", value: 1 }]; // Reseta para ABERTA
      this.loadSacSolicitacoes(); // Recarrega com os filtros limpos
    },

    loadCarregaSac(solicitacao) {
      // Carrega os dados de uma solicitação selecionada para o formulário
      this.sacsolicitacao = { ...solicitacao };
      this.mode = "update"; // Define o modo para atualização
      this.loadSacSolicitacoesTratativas(); // Carrega as tratativas associadas
      this.loadSolicitacaoFoto(); // Carrega fotos associadas
      this.loadDepartamentos(); // Recarrega departamentos (se necessário para o formulário)
      this.loadAssunto(); // Recarrega assuntos (se necessário)
      this.loadMotivo(); // Recarrega motivos (se necessário)
    },
    loadCarregaSacT(tratativa) {
      // Este método parece ser para carregar uma *única* tratativa.
      // Se você precisa exibir detalhes de uma tratativa específica, mantenha.
      // Se sacsolicitacoestratativa é sempre um array de *todas* as tratativas, este pode não ser necessário.
      this.sacT = { ...tratativa }; // Atribui para um objeto sacT separado, não sobrescreve o array
    },

    // --- Métodos de Carregamento de Dados (API GET) ---
    loadDepartamentos() {
      let params = {
        origem: "app",
        empresa_id: `${this.user.id_grupo_empresa}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/informatica/sac/departamento`;
      axios
        .get(url, { params })
        .then((res) => {
          this.departamentos = res.data.map((inte) => {
            return { ...inte, value: inte.id_area, area: inte.area };
          });
        })
        .catch(showError);
    },

    loadAssunto() {
      // Garante que o departamento_id exista antes de carregar assuntos
      if (!this.sacsolicitacao.departamento_id) return;

      let params = {
        origem: "app",
        empresa_id: `${this.user.id_grupo_empresa}`,
        depto_id: `${this.sacsolicitacao.departamento_id}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/informatica/sac/assunto`;
      axios
        .get(url, { params })
        .then((res) => {
          this.assuntos = res.data.map((inte) => {
            return { ...inte, value: inte.id_modulo, area: inte.modulo };
          });
        })
        .catch(showError);
    },

    loadMotivo() {
      // Garante que o assunto_id exista antes de carregar motivos
      if (!this.sacsolicitacao.assunto_id) return;

      let params = {
        origem: "app",
        empresa_id: `${this.user.id_grupo_empresa}`,
        modulo_id: `${this.sacsolicitacao.assunto_id}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/informatica/sac/motivo`;
      axios
        .get(url, { params })
        .then((res) => {
          this.motivos = res.data.map((inte) => {
            return {
              ...inte,
              value: inte.id,
              area: inte.motivo,
              atestado: inte.atestado,
            };
          });
        })
        .catch(showError);
    },

    loadEmpresas() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/ctr/empresa`;
      axios.get(url, { params }).then((res) => {
        this.empresas = res.data.map((empresa) => {
          return {
            id_empresa: empresa.id_empresa,
            empresa: empresa.nomeempresarial,
          };
        });
      });
    },

    loadFiliais() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        id_empresa: `${this.user.id_empresa}`, // Ou this.value_empresa se for selecionada
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/ctr/empresa/filial`;
      axios.get(url, { params }).then((res) => {
        this.filiais = res.data.map((filial) => {
          return { id_filial_erp: filial.id_filial_erp, filial: filial.filial };
        });
      });
    },

    loadStatus() {
      let params = {
        id_grupo: `${this.user.id_grupo}`,
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/sac/status`;
      axios.get(url, { params }).then((res) => {
        this.statuss = res.data.map((sta) => {
          return { ...sta, value: sta.id_status, status: sta.status };
        });
        // Define o status inicial do filtro para 'ABERTA' (ID 1)
        if (this.value_status.length === 0) {
          const statusAberto = this.statuss.find((s) => s.id_status === 1);
          if (statusAberto) {
            this.value_status = [statusAberto];
          }
        }
      });
    },

    loadResposta() {
      let params = {
        id_grupo: `${this.user.id_grupo}`,
        empresa_id: `${this.user.id_empresa}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/sac/resposta`;
      axios.get(url, { params }).then((res) => {
        this.sacResposta = res.data.map((resp) => {
          return { ...resp, value: resp.id, resposta: resp.resposta };
        });
      });
    },

    async loadPermissao() {
      let params = {
        id_grupo: `${this.user.id_grupo}`,
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/sac/permissao`;

      try {
        const res = await axios.get(url, { params });
        this.permissoes = res.data.map((permissao) => {
          return { ...permissao, id_area: permissao.id_area };
        });
        // Após carregar as permissões, recarrega as solicitações
        this.loadSacSolicitacoes();
        // Após carregar as permissões, tenta juntar às salas do Socket.IO
        this.joinSocketRooms();
      } catch (error) {
        console.error("Erro ao carregar permissões:", error);
        showError(error);
      }
    },

    async loadSacSolicitacoes() {
      this.isLoading = true; // Ativa o modal de carregamento
      let params = {
        empresa_id:
          this.value_empresa.length > 0
            ? `${this.value_empresa.map((e) => e.id_empresa).join(",")}` // Juntar IDs com vírgula
            : `${this.user.id_empresa}`,
        funcionario_id: `${this.user.id_funcionario}`,
        status_id:
          this.value_status.length > 0
            ? `${this.value_status.map((r) => r.id_status).join(",")}` // Juntar IDs com vírgula
            : "1", // Default para '1' (ABERTA)
        tipo: "solicitante", // Pode ser 'solicitante' ou 'analista' ou 'todos'
        origem: "web",
        // Ajuste para gestor, garantindo que seja string 'true' ou 'false'
        gestor: this.user.gestor ? "true" : "false",
        id_area: this.permissoes.map((p) => p.id_area).join(","),
        psg: this.user.psg,
      };

      const url = `${baseApiUrl}/sac/solicitacoes_v2`;
      try {
        const res = await axios.get(url, { params });
        // **CORREÇÃO CRÍTICA AQUI:** Use Object.values se a API retorna um objeto
        // com chaves numéricas ao invés de um array diretamente.
        // Se a API já retorna um array, remova o Object.values().
        if (
          res.data &&
          typeof res.data === "object" &&
          !Array.isArray(res.data)
        ) {
          this.sacsolicitacoes = Object.values(res.data).map((s) => ({
            id_solicitacao: s.id_solicitacao,
            id_empresa: s.id_empresa,
            id_filial: s.id_filial,
            dt_abertura: s.dt_abertura,
            dt_inclusao: s.dt_inclusao,
            dt_cadastro: s.dt_cadastro,
            area: s.area,
            modulo: s.modulo,
            id_funcionario_solicitante: s.id_funcionario_solicitante,
            re_solicitante: s.re_solicitante,
            funcao_solicitante: s.funcao_solicitante,
            justificativa: s.justificativa,
            id_status: s.id_status,
            status: s.status,
            statuss: s.statuss,
            id_funcionario_analise: s.id_funcionario_analise,
            re_analisado: s.re_analisado,
            dt_analise: s.dt_analise,
            id_funcionario_finalizada: s.id_funcionario_finalizada,
            re_finalizado: s.re_finalizado,
            dt_finalizada: s.dt_finalizada,
            parecer: s.parecer,
            id_leitura: s.id_leitura,
            leitura: s.leitura,
            foto_url: s.foto_url,
            nome: s.nome,
            tempo: s.tempo,
            pedido_ferias: s.pedido_ferias,
            aprovado: s.aprovado,
            exige_liberacao: s.exige_liberacao,
            avaliacao: s.avaliacao,
            dt_atestado_ini: s.dt_atestado_ini,
            dt_atestado_fim: s.dt_atestado_fim,
          }));
        } else {
          this.sacsolicitacoes = res.data.map((s) => ({
            id_solicitacao: s.id_solicitacao,
            id_empresa: s.id_empresa,
            id_filial: s.id_filial,
            dt_abertura: s.dt_abertura,
            dt_inclusao: s.dt_inclusao,
            dt_cadastro: s.dt_cadastro,
            area: s.area,
            modulo: s.modulo,
            id_funcionario_solicitante: s.id_funcionario_solicitante,
            re_solicitante: s.re_solicitante,
            funcao_solicitante: s.funcao_solicitante,
            justificativa: s.justificativa,
            id_status: s.id_status,
            status: s.status,
            statuss: s.statuss,
            id_funcionario_analise: s.id_funcionario_analise,
            re_analisado: s.re_analisado,
            dt_analise: s.dt_analise,
            id_funcionario_finalizada: s.id_funcionario_finalizada,
            re_finalizado: s.re_finalizado,
            dt_finalizada: s.dt_finalizada,
            parecer: s.parecer,
            id_leitura: s.id_leitura,
            leitura: s.leitura,
            foto_url: s.foto_url,
            nome: s.nome,
            tempo: s.tempo,
            pedido_ferias: s.pedido_ferias,
            aprovado: s.aprovado,
            exige_liberacao: s.exige_liberacao,
            avaliacao: s.avaliacao,
            dt_atestado_ini: s.dt_atestado_ini,
            dt_atestado_fim: s.dt_atestado_fim,
          }));
        }
        console.log("Dados da tabela carregados:", this.sacsolicitacoes);
      } catch (err) {
        console.error("Erro ao carregar solicitações:", err);
        showError(err);
      } finally {
        this.isLoading = false; // Desativa o modal de carregamento
      }
    },

    loadSacSolicitacoesTratativas() {
      // Garante que haja um id_solicitacao para buscar as tratativas
      if (!this.sacsolicitacao.id_solicitacao) return;

      let params = {
        id_solicitacao: `${this.sacsolicitacao.id_solicitacao}`,
        psg: this.user.psg,
      };

      const url = `${baseApiUrl}/sac/solicitacoes/id`;
      axios
        .get(url, { params })
        .then((res) => {
          this.sacsolicitacoestratativa = res.data.map((sacT) => {
            return {
              id_solicitacao: sacT.id_solicitacao,
              dt_resposta: sacT.dt_resposta,
              id_respondido: sacT.id_respondido,
              respondido: sacT.respondido,
              registro: sacT.registro,
              justificativa: sacT.justificativa,
              id_status_leitura: sacT.id_status_leitura,
              status: sacT.status,
            };
          });
        })
        .catch(showError);
    },

    loadSolicitacaoFoto() {
      // Garante que haja um id_solicitacao para buscar as fotos
      if (!this.sacsolicitacao.id_solicitacao) return;

      let params = {
        empresa_id: `${this.user.id_empresa}`,
        solicitacao_id: `${this.sacsolicitacao.id_solicitacao}`,
        origem: "consulta",
        psg: this.user.psg,
      };

      const url = `${baseApiUrl}/sac/solicitacoes_v2/arquivos`;

      axios
        .get(url, { params })
        .then((res) => {
          this.solicitacao = res.data; // Parece que 'solicitacao' é para a foto
        })
        .catch((error) => {
          console.error("Erro ao carregar solicitação de foto:", error);
          showError(error);
        });
    },

    // --- Métodos de Envio de Dados (API POST/PUT) ---
    async postSac() {
      // Determina se é uma atualização ou nova criaçãosacsolicitacao
      const isUpdate = this.sacsolicitacao.id_solicitacao;
      //  const method = isUpdate ? "put" : "post";
      const method = "post";
      let url = `${baseApiUrl}/informatica/sac/lancamentos`;

      let corpo = {
        id_empresa_grupo: `${this.user.id_grupo_empresa}`,
        empresa_id: `${this.user.id_grupo_empresa}`,
        filial_id: `${this.user.id_filial_erp}`,
        id_funcionario: `${this.user.id_funcionario}`,
        id_area: `${this.sacsolicitacao.departamento_id}`,
        id_modulo: `${this.sacsolicitacao.assunto_id}`,
        id_motivo: `${this.sacsolicitacao.motivo_id}`,
        justificativa: `${this.sacsolicitacao.parecer}`, // Usa o parecer como justificativa aqui
        id_solicitacao: isUpdate
          ? `${this.sacsolicitacao.id_solicitacao}`
          : null, // ID apenas para update
        aprovado: this.sacsolicitacao.aprovado
          ? `${this.sacsolicitacao.aprovado}`
          : false,
        funcionario_aprovacao_id: `${this.user.id_funcionario}`,
        dt_aprovacao: `${this.sacsolicitacao.dt_aprovacao || ""}`, // Garante que não seja 'undefined'
        dt_atestado_ini: `${this.sacsolicitacao.dt_atestado_ini || ""}`, // Garante que não seja 'undefined'
        dt_atestado_fim: `${this.sacsolicitacao.dt_atestado_fim || ""}`, // Garante que não seja 'undefined'
        psg: this.user.psg,
      };

      // Se for PUT (atualização), o ID deve estar na URL
      if (isUpdate) {
        url = `${url}`;
      }

      try {
        const res = await axios[method](url, corpo);

        if (res.data && res.data.dados && res.data.dados.length > 0) {
          this.idRetornoSolicitacao = res.data.dados[0].id_solicitacao;

          // Chama a função postSacTratativa após o sucesso de postSac
          await this.postSacTratativa(); // Usa await para garantir que a tratativa seja enviada antes de continuar

          this.loadSacSolicitacoes(); // Recarrega a tabela principal
          this.$bvModal.hide("modal-multi-tratativas"); // Esconde o modal
          this.reset(); // Limpa o formulário
        } else {
          console.error("Estrutura de dados inesperada na resposta:", res.data);
          showError(
            "Erro: Resposta do servidor inesperada ao salvar solicitação."
          );
        }
      } catch (error) {
        console.error("Erro ao salvar solicitação:", error);
        showError(error);
      }
    },

    async postSacTratativa() {
      // Usa o idRetornoSolicitacao (da nova criação) ou o id_solicitacao (da atualização)
      const solicitacaoIdParaTratativa =
        this.idRetornoSolicitacao || this.sacsolicitacao.id_solicitacao;

      if (!solicitacaoIdParaTratativa) {
        console.warn(
          "Não foi possível enviar a tratativa: ID da solicitação ausente."
        );
        return; // Sai da função se não houver ID
      }

      let corpo = {
        id_solicitacao: `${solicitacaoIdParaTratativa}`,
        justificativa: this.sacsolicitacao.parecer
          ? `${this.sacsolicitacao.parecer}`
          : null,
        id_funcionario_resposta: `${this.user.id_funcionario}`,
        respondido_por: 1, // '1' ou outro valor padrão
        origem: "solicitacao",
        psg: this.user.psg,
      };

      const url = `${baseApiUrl}/informatica/sac/lancamentostratativas`;

      try {
        await axios.post(url, corpo);
        this.$toasted.global.defaultSuccess();
        this.sacsolicitacao.parecer = ""; // Limpa o campo de parecer
        // Não é necessário chamar loadSacSolicitacoes() aqui novamente,
        // pois já é chamado após o postSac() principal.
      } catch (error) {
        console.error("Erro ao enviar tratativa:", error);
        showError(error);
      }
    },

    uptAvaliacao() {
      const solicitacaoIdParaAvaliacao =
        this.sacsolicitacao.id_solicitacao || this.idRetornoSolicitacao;
      if (!solicitacaoIdParaAvaliacao) {
        console.warn("Não foi possível avaliar: ID da solicitação ausente.");
        return;
      }

      let corpo = {
        id_solicitacao: `${solicitacaoIdParaAvaliacao}`,
        avaliacao: `${this.sacsolicitacao.avaliacao}`,
        psg: this.user.psg,
      };

      const url = `${baseApiUrl}/informatica/sac/avaliacaosolicitacao`;

      axios
        .put(url, corpo)
        .then(() => {
          this.$toasted.global.defaultSuccess();
          this.loadSacSolicitacoes(); // Recarrega para refletir a avaliação
        })
        .catch(showError);
    },

    // --- Lógica de Socket.IO ---
    joinSocketRooms() {
      if (
        this.$socket &&
        this.user &&
        this.user.id_funcionario &&
        this.permissoes.length > 0
      ) {
        console.log("Tentando emitir 'authenticateUser' e 'joinRooms'...");
        // Emite o evento de autenticação para o backend
        this.$socket.emit("authenticateUser", this.user.id_funcionario);

        // Envia os IDs das áreas (permissões) para o backend para que o socket se junte às salas corretas
        const userAreaIds = this.permissoes.map((p) => String(p.id_area)); // Garante que sejam strings
        if (userAreaIds.length > 0) {
          this.$socket.emit("joinRooms", userAreaIds); // O evento 'joinRooms' deve ser tratado no backend
          console.log("Emitido 'joinRooms' para as salas:", userAreaIds);
        }
      } else {
        console.warn(
          "Socket.IO não disponível ou dados do usuário/permissões incompletos para juntar salas."
        );
      }
    },
  },

  created() {
    this.loadStatus(); // Carrega status antes de carregar solicitações
    this.loadPermissao(); // Carrega permissões e, em seguida, carrega solicitações e tenta juntar salas
    this.loadEmpresas(); // Carrega empresas (para o filtro)
    this.loadFiliais(); // Carrega filiais (para o filtro)
    this.loadResposta(); // Carrega respostas predefinidas
  },

  mounted() {
    // Escutando eventos de conexão/desconexão para depuração
    // É importante que o plugin do Socket.IO para Vue esteja configurado corretamente
    // para que '$socket' esteja disponível.
    if (this.$socket) {
      console.log("Socket.IO está disponível no mounted.");

      this.$socket.on("connect", () => {
        console.log("Conectado ao Socket.IO do frontend!");
        this.joinSocketRooms(); // Tenta juntar as salas novamente em caso de reconexão
      });

      this.$socket.on("disconnect", () => {
        console.warn("Desconectado do Socket.IO do frontend!");
      });

      this.$socket.on("connect_error", (error) => {
        console.error("Erro de conexão do Socket.IO:", error);
      });

      // --- Listeners para Notificações ---
      // Evento para quando uma solicitação é atualizada e deve ser notificada ao usuário que a criou
      this.$socket.on("solicitacaoAtualizadaUsuario", (data) => {
        this.$bvToast.toast(data.message, {
          title: "SAC Atualizado",
          variant: "info",
          solid: true,
          autoHideDelay: 5000,
        });
        // Recarrega as solicitações para o usuário ver a atualização
        this.loadSacSolicitacoes();
      });

      // Evento para quando uma NOVA solicitação é criada e deve ser notificada ao departamento responsável
      this.$socket.on("novaSolicitacaoDepartamento", (data) => {
        this.$bvToast.toast(data.message, {
          title: "Nova Solicitação SAC",
          variant: "success",
          solid: true,
          autoHideDelay: 5000,
        });
        this.loadSacSolicitacoes(); // Recarrega a lista para mostrar a nova solicitação
      });

      // Evento para quando uma solicitação existente é ATUALIZADA e deve ser notificada ao departamento responsável
      this.$socket.on("solicitacaoAtualizadaDepartamento", (data) => {
        this.$bvToast.toast(data.message, {
          title: "Atualização SAC (Departamento)",
          variant: "warning",
          solid: true,
          autoHideDelay: 5000,
        });
        this.loadSacSolicitacoes(); // Recarrega a lista para mostrar a atualização
      });

      // Listener para a mensagem de "Usuário não está online" (se o backend enviar isso para o frontend)
      this.$socket.on("usuarioOfflineNotification", (data) => {
        this.$bvToast.toast(data.message, {
          title: "Aviso de Notificação",
          variant: "danger",
          solid: true,
          autoHideDelay: 5000,
        });
        console.warn("Mensagem do backend:", data.message);
      });

      // Tenta juntar as salas também no mounted, caso o created já tenha sido disparado
      // e o socket não estivesse totalmente pronto ou autenticado.
      // A chamada em `loadPermissao` é preferencial para garantir que as áreas estejam disponíveis.
      // Se `this.user` e `this.permissoes` já estiverem carregados, esta chamada será efetiva.
      this.joinSocketRooms();
    } else {
      console.error(
        "Plugin Socket.IO não está configurado ou disponível em '$socket'."
      );
    }
  },
  beforeDestroy() {
    // É uma boa prática desconectar o socket quando o componente é destruído
    if (this.$socket) {
      this.$socket.off("connect");
      this.$socket.off("disconnect");
      this.$socket.off("connect_error");
      this.$socket.off("solicitacaoAtualizadaUsuario");
      this.$socket.off("novaSolicitacaoDepartamento");
      this.$socket.off("solicitacaoAtualizadaDepartamento");
      this.$socket.off("usuarioOfflineNotification");
      // Se você tiver um método `disconnect` no seu plugin Vue-Socket.io, chame-o aqui.
      // Geralmente, o plugin gerencia a reconexão automaticamente, mas para limpeza explícita:
      // this.$socket.disconnect(); // Descomente se isso for necessário para evitar duplicação ou vazamento de memória.
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
#selecaostatusx {
  font-size: 0.9em;
}

#re-nome {
  font-size: 0.9em;
}

#funcao {
  font-size: 0.9em;
}

#re-solicitante {
  font-size: 0.9em;
  font-style: inherit;
}

#parecer {
  font-size: 0.9em;
}

#rfilancamentos {
  font-size: 0.9em;
  text-align: center;
}

#resolicitante {
  font-size: 14px; /* Ajuste o tamanho da fonte conforme necessário */
}
</style>
